import { CountryListType, GeAndUsStatesType, OptsType, ProductList } from '../types';

// 国家列表选项
export const countryList: CountryListType[] = [
    {
        text: 'United States',
        shortName: 'us',
        key: '1',
    },
    {
        text: 'Germany',
        shortName: 'de',
        key: '2',
    },
    {
        text: 'France',
        shortName: 'fr',
        key: '3',
    },
    {
        text: 'Canada',
        shortName: 'ca',
        key: '4',
    },
    {
        text: 'United Kingdom',
        shortName: 'uk',
        key: '5',
    },
    {
        text: 'Australia',
        shortName: 'au',
        key: '6',
    },
    {
        text: 'Japan',
        shortName: 'jp',
        key: '7',
    },
    {
        text: 'Korea',
        shortName: 'kr',
        key: '8',
    },
    {
        text: 'Italy',
        shortName: 'it',
        key: '9',
    },
    {
        text: 'Spain',
        shortName: 'es',
        key: '10',
    },
];

// 州/省/地区
export const geAndUsStates: GeAndUsStatesType = {
    us: [
        {
            name: 'Alaska',
        },
        {
            name: 'Alabama',
        },
        {
            name: 'Arkansas',
        },
        {
            name: 'Arizona',
        },
        {
            name: 'California',
        },
        {
            name: 'Colorado',
        },
        {
            name: 'Connecticut',
        },
        {
            name: 'District of Columbia',
        },
        {
            name: 'Delaware',
        },
        {
            name: 'Florida',
        },
        {
            name: 'Georgia',
        },
        {
            name: 'Hawaii',
        },
        {
            name: 'Iowa',
        },
        {
            name: 'Idaho',
        },
        {
            name: 'Illinois',
        },
        {
            name: 'Indiana',
        },
        {
            name: 'Kansas',
        },
        {
            name: 'Kentucky',
        },
        {
            name: 'Louisiana',
        },
        {
            name: 'Massachusetts',
        },
        {
            name: 'Maryland',
        },
        {
            name: 'Maine',
        },
        {
            name: 'Michigan',
        },
        {
            name: 'Minnesota',
        },
        {
            name: 'Missouri',
        },
        {
            name: 'Mississippi',
        },
        {
            name: 'Montana',
        },
        {
            name: 'North Carolina',
        },
        {
            name: 'North Dakota',
        },
        {
            name: 'Nebraska',
        },
        {
            name: 'New Hampshire',
        },
        {
            name: 'New Jersey',
        },
        {
            name: 'New Mexico',
        },
        {
            name: 'Nevada',
        },
        {
            name: 'New York',
        },
        {
            name: 'Ohio',
        },
        {
            name: 'Oklahoma',
        },
        {
            name: 'Oregon',
        },
        {
            name: 'Pennsylvania',
        },
        {
            name: 'Puerto Rico',
        },
        {
            name: 'Rhode Island',
        },
        {
            name: 'South Carolina',
        },
        {
            name: 'South Dakota',
        },
        {
            name: 'Tennessee',
        },
        {
            name: 'Texas',
        },
        {
            name: 'Utah',
        },
        {
            name: 'Virginia',
        },
        {
            name: 'Vermont',
        },
        {
            name: 'Washington',
        },
        {
            name: 'Wisconsin',
        },
        {
            name: 'West Virginia',
        },
        {
            name: 'Wyoming',
        },
    ],
    de: [
        {
            name: 'Baden-Württemberg',
        },
        {
            name: 'Bavaria(Bayern)',
        },
        {
            name: 'Berlin',
        },
        {
            name: 'Brandenburg',
        },
        {
            name: 'Bremen',
        },
        {
            name: 'Hamburg',
        },
        {
            name: 'Hesse(Hessen)',
        },
        {
            name: 'Lower Saxony (Niedersachsen)',
        },
        {
            name: 'Mecklenburg-Vorpommern',
        },
        {
            name: 'North Rhine-Westphalia (Nordrhein-Westfalen)',
        },
        {
            name: 'Rhineland-Palatinate(Rheinland-Pfalz)',
        },
        {
            name: 'Saarland',
        },
        {
            name: 'Saxony(Sachsen)',
        },
        {
            name: 'Saxony-Anhalt (Sachsen-Anhalt)',
        },
        {
            name: 'Schleswig-Holstein',
        },
        {
            name: 'Thuringia(Thüringen)',
        },
    ],
    fr: [
        {
            name: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Bretagne',
        },
        {
            name: 'Centre-Val de Loire',
        },
        {
            name: 'Corse',
        },
        {
            name: 'Grand Est',
        },
        {
            name: 'Hauts-de-France',
        },
        {
            name: 'Île-de-France',
        },
        {
            name: 'Normandie',
        },
        {
            name: 'Nouvelle-Aquitaine',
        },
        {
            name: 'Occitanie',
        },
        {
            name: 'Pays de la Loire',
        },
        {
            name: "Provence-Alpes-Côte d'Azur",
        },
    ],
    uk: [
        {
            name: 'North East (England)',
        },
        {
            name: 'North West (England)',
        },
        {
            name: 'Yorkshire and The Humber',
        },
        {
            name: 'East Midlands (England)',
        },
        {
            name: 'West Midlands (England)',
        },
        {
            name: 'East of England',
        },
        {
            name: 'London',
        },
        {
            name: 'South East (England)',
        },
        {
            name: 'South West (England)',
        },
        {
            name: 'Scotland',
        },
        {
            name: 'Wales',
        },
        {
            name: 'Northern Ireland',
        },
    ],
    ca: [
        {
            name: 'Alberta',
        },
        {
            name: 'British Columbia',
        },
        {
            name: 'Manitoba',
        },
        {
            name: 'New Brunswick',
        },
        {
            name: 'Newfoundland and Labrador',
        },
        {
            name: 'Northwest Territories',
        },
        {
            name: 'Nova Scotia',
        },
        {
            name: 'Nunavut',
        },
        {
            name: 'Ontario',
        },
        {
            name: 'Prince Edward Island',
        },
        {
            name: 'Quebec',
        },
        {
            name: 'Saskatchewan',
        },
        {
            name: 'Yukon',
        },
    ],
    au: [
        {
            name: 'Australian Capital Territory',
        },
        {
            name: 'New South Wales',
        },
        {
            name: 'Northern Territory',
        },
        {
            name: 'Queensland',
        },
        {
            name: 'South Australia',
        },
        {
            name: 'Tasmania',
        },
        {
            name: 'Victoria',
        },
        {
            name: 'Western Australia',
        },
    ],
    jp: [
        {
            name: '北海道',
        },
        {
            name: '青森県',
        },
        {
            name: '岩手県',
        },
        {
            name: '宮城県',
        },
        {
            name: '秋田県',
        },
        {
            name: '山形県',
        },
        {
            name: '福島県',
        },
        {
            name: '茨城県',
        },
        {
            name: '栃木県',
        },
        {
            name: '群馬県',
        },
        {
            name: '埼玉県',
        },
        {
            name: '千葉県',
        },
        {
            name: '東京都',
        },
        {
            name: '神奈川県',
        },
        {
            name: '新潟県',
        },
        {
            name: '富山県',
        },
        {
            name: '石川県',
        },
        {
            name: '福井県',
        },
        {
            name: '山梨県',
        },
        {
            name: '長野県',
        },
        {
            name: '岐阜県',
        },
        {
            name: '静岡県',
        },
        {
            name: '愛知県',
        },
        {
            name: '三重県',
        },
        {
            name: '滋賀県',
        },
        {
            name: '京都府',
        },
        {
            name: '大阪府',
        },
        {
            name: '兵庫県',
        },
        {
            name: '奈良県',
        },
        {
            name: '和歌山県',
        },
        {
            name: '鳥取県',
        },
        {
            name: '島根県',
        },
        {
            name: '岡山県',
        },
        {
            name: '広島県',
        },
        {
            name: '山口県',
        },
        {
            name: '徳島県',
        },
        {
            name: '香川県',
        },
        {
            name: '愛媛県',
        },
        {
            name: '福岡県',
        },
        {
            name: '佐賀県',
        },
        {
            name: '長崎県',
        },
        {
            name: '熊本県',
        },
        {
            name: '大分県',
        },
        {
            name: '宮崎県',
        },
        {
            name: '鹿児島県',
        },
        {
            name: '沖縄県',
        },
    ],
    kr: [
        {
            name: '강원도',
        },
        {
            name: '경기도',
        },
        {
            name: '경상남도',
        },
        {
            name: '경상북도',
        },
        {
            name: '광주광역시',
        },
        {
            name: '대구광역시',
        },
        {
            name: '부산광역시',
        },
        {
            name: '서울특별시',
        },
        {
            name: '세종특별자치시',
        },
        {
            name: '울산광역시',
        },
        {
            name: '인천광역시',
        },
        {
            name: '전라남도',
        },
        {
            name: '전라북도',
        },
        {
            name: '제주특별자치도',
        },
        {
            name: '충청남도',
        },
        {
            name: '충청북도',
        },
        {
            name: '대전광역시',
        },
    ],
    it: [
        { name: 'Abruzzo' },
        { name: "Valle d'Aosta" },
        { name: 'Puglia' },
        { name: 'Basilicata' },
        { name: 'Calabria' },
        { name: 'Campania' },
        { name: 'Emilia-Romagna' },
        { name: 'Furlanija-Julijska Krajina/Friûl-Vignesie Julie' },
        { name: 'Lazio' },
        { name: 'Liguria' },
        { name: 'Lombardia' },
        { name: 'Marche' },
        { name: 'Molise' },
        { name: 'Piemonte' },
        { name: 'Sardegna' },
        { name: 'Sicilia' },
        { name: 'Trentino-Alto Adige/Südtirol' },
        { name: 'Toscana' },
        { name: 'Umbria' },
        { name: 'Veneto' },
    ],
    es: [
        { name: 'Andalucía' },
        { name: 'Cataluña' },
        { name: 'Comunidad de Madrid' },
        { name: 'Comunidad Valenciana' },
        { name: 'Galicia' },
        { name: 'Castilla y León' },
        { name: 'País Vasco' },
        { name: 'Castilla-La Mancha' },
        { name: 'Canarias' },
        { name: 'Región de Murcia' },
        { name: 'Aragón' },
        { name: 'Extremadura' },
        { name: 'Islas Baleares' },
        { name: 'Principado de Asturias' },
        { name: 'Comunidad Foral de Navarra' },
        { name: 'Cantabria' },
        { name: 'La Rioja' },
        { name: 'Melilla' },
        { name: 'Ceuta' },
    ],
};

/**
 * @param {string} value 前端组件选中值字段
 * @param {string} text 多语言t函数字段
 * @param {string} code 预留后端接口参数字段
 * @param {'item' | 'input'} [type]
 */
export const installList: OptsType[] = [
    {
        value: 'Vans/RVs/Trailers',
        text: 'presale.preorder.powerkits_opt_car',
        code: '1',
        type: 'item',
    },
    {
        value: 'Off-grid Builds',
        text: 'presale.preorder.powerkits_opt_builds',
        code: '2',
        type: 'item',
    },
    // {
    //     value: 'Home',
    //     text: 'presale.preorder.powerkits_opt_home',
    //     code: '3',
    //     type: 'item',
    // },
    {
        value: 'Others',
        text: 'presale.preorder.powerkits_opt_other',
        code: '4',
        type: 'input',
    },
];
export const dateList: OptsType[] = [
    {
        value: 'Weekdays',
        text: 'presale.preorder.date_opt_Weekdays',
        code: '1',
        type: 'item',
    },
    {
        value: 'Weekends',
        text: 'presale.preorder.date_opt_Weekends',
        code: '2',
        type: 'item',
    },
];

export const paymentOptions: OptsType[] = [
    {
        value: 'Yes',
        text: 'presale.preorder.option_yes',
        code: '1',
        type: 'item',
    },
    {
        value: 'No',
        text: 'presale.preorder.option_no',
        code: '2',
        type: 'item',
    },
];

export const timeList: OptsType[] = [
    {
        value: '9:00 a.m. - 12:00 p.m.',
        text: 'presale.preorder.time_opt_one',
        code: '1',
        type: 'item',
    },
    {
        value: '12:00 p.m. - 15:00 p.m.',
        text: 'presale.preorder.time_opt_two',
        code: '2',
        type: 'item',
    },
    {
        value: '15:00 p.m. - 18:00 p.m.',
        text: 'presale.preorder.time_opt_thr',
        code: '3',
        type: 'item',
    },
    {
        value: 'Others',
        text: 'presale.preorder.time_opt_fou',
        code: '4',
        type: 'input',
    },
];

export enum SiteMap {
    us = 'en-us',
    ca = 'en-ca',
    uk = 'en-uk',
    eu = 'en-eu',
    za = 'en-za',
    au = 'en-au',
    de = 'de-de',
    fr = 'fr-fr',
    es = 'es-es',
    it = 'it-it',
    jp = 'ja-jp',
    kr = 'ko-kr',
    cn = 'zh-cn',
    ru = 'ru-ru',
    cis = 'ru-cis',
    nl = 'nl-nl',
    tw = 'zh-tw',
}

export const productLists: ProductList[] = [
    {
        key: 'Power Kits (With LFP Batteries)',
        value: 'Power Kits (With LFP Batteries)',
    },
    {
        key: 'Power Kits 2kWh LFP Battery (Only)',
        value: 'Power Kits 2kWh LFP Battery (Only)',
    },
    {
        key: 'Power Kits 5kWh LFP Battery (Only)',
        value: 'Power Kits 5kWh LFP Battery (Only)',
    },
    {
        key: 'DELTA PRO',
        value: 'DELTA PRO',
    },
    {
        key: 'DELTA Series (Other than DELTA PRO)',
        value: 'DELTA Series (Other than DELTA PRO)',
    },
    {
        key: 'Smart Generator',
        value: 'Smart Generator',
    },
    {
        key: 'Smart Generator (Dual Fuel)',
        value: 'Smart Generator (Dual Fuel)',
    },
    {
        key: 'Rigid Solar Panels',
        value: 'Rigid Solar Panels',
    },
    {
        key: 'Portable/Flexible Solar Panels',
        value: 'Portable/Flexible Solar Panels',
    },
    {
        key: 'EcoFlow Wave',
        value: 'EcoFlow Wave',
    },
    {
        key: 'Smart Home Panel',
        value: 'Smart Home Panel',
    },
    {
        key: 'RIVER Series',
        value: 'RIVER Series',
    },
    {
        key: '0',
        value: "I don't have any EcoFlow product for now",
    },
];

export type SiteMapkeyType = keyof typeof SiteMap;
